// OR Custom: megamenu_style_2 — level-3 side flyout.
// The subsections panel (.site-nav-sub) shows only for the active group
// (.or-flyout-active): the first group with children is active by default,
// hovering another group switches the panel, leaving the dropdown resets it.
// Desktop-only visually (the CSS is scoped to min-width: 1025px).
(function () {
    'use strict';

    if (window.orMegaFlyoutInit) return;
    window.orMegaFlyoutInit = true;

    function groups(col) {
        return Array.prototype.filter.call(col.children, function (el) {
            return el.classList.contains('site-nav') && el.querySelector('.site-nav-sub');
        });
    }

    function setActive(col, target) {
        groups(col).forEach(function (g) {
            g.classList.toggle('or-flyout-active', g === target);
        });
    }

    function init() {
        document.querySelectorAll('.megamenu_style_2 .or-col-flow').forEach(function (col) {
            var gs = groups(col);
            if (!gs.length) return;

            col.classList.add('or-has-flyout');
            setActive(col, gs[0]);

            col.addEventListener('mouseover', function (e) {
                var g = e.target.closest('.site-nav');
                if (g && col.contains(g) && g.querySelector('.site-nav-sub')) {
                    setActive(col, g);
                }
            });

            var dropdown = col.closest('.menu-dropdown');
            if (dropdown) {
                dropdown.addEventListener('mouseleave', function () {
                    setActive(col, gs[0]);
                });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
